import React from 'react';
import LimitsThresholdsSection from '../../../sections/AdminDashboard/Configuration/LimitsThresholds';

const LimitsThresholds = () => <LimitsThresholdsSection />;

export default LimitsThresholds;
